<template>
  <div>
    <SubSideMenu
      :subsection="'Reports'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from '@/components/SideMenu/SubSideMenu/SubSideMenu.vue'

export default {
  name: 'ReportsSidebar',
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["reportsNav"]),
    options() {
      return this.reportsNav
    }
  }
}
</script>